import _createStore from 'redux/store'
import createReducers from './createReducers'


let _store

const reducers = createReducers(() => _store.dispatch)

const getState = () => {
  if (process.env.WEBPACK === 'build.server') {
    console.error('DON\'T USE getState() ON SERVER SIDE!')
    // throw new Error('DON\'T USE getState() ON SERVER SIDE!')
  }
  else {
    return _store.getState()
  }
}

const createStore = (initialState) => {
  const { store, storeEvents } = _createStore(initialState)

  _store = store

  return { store, storeEvents }
}


export {
  createStore,
  getState,
  reducers,
}
